import React from 'react'
import Banner, { BannerProps } from './Banner'

const Error = (props: ErrorProps) => <Banner color="#C45A5A" {...props} />

export default Error

export interface ErrorProps extends Omit<BannerProps, 'color'> {}
